enum EnvelopeStatuses {
  Completed = 'completed',
  Correct = 'correct',
  Created = 'created',
  Declined = 'declined',
  Delivered = 'delivered',
  Sent = 'sent',
  Signed = 'signed',
  Template = 'template',
  Voided = 'voided',
}
export default EnvelopeStatuses;
export type VerifyEnvelopeStatuses = Utils.VerifyExtends<
  Model.Enum.EnvelopeStatuses,
  Utils.ValueOf<typeof EnvelopeStatuses>
>;
